var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "content-form__switch-field" }, [
    _c("div", { staticClass: "content-form__switcher-wrap" }, [
      _c("div", { staticClass: "content-form__switcher-label" }, [
        _vm._v("\n        Calendar view\n      "),
      ]),
      _c(
        "label",
        {
          staticClass: "switcher",
          class: { selected: _vm.calendarState.enabled },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.calendarState.enabled,
                expression: "calendarState.enabled",
              },
            ],
            staticClass: "switcher__input",
            attrs: { type: "checkbox", value: "tiles" },
            domProps: {
              checked: Array.isArray(_vm.calendarState.enabled)
                ? _vm._i(_vm.calendarState.enabled, "tiles") > -1
                : _vm.calendarState.enabled,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.calendarState.enabled,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = "tiles",
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.calendarState,
                          "enabled",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.calendarState,
                          "enabled",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.calendarState, "enabled", $$c)
                  }
                },
                function ($event) {
                  return _vm.$trackFeature(
                    "content",
                    "calendarView",
                    _vm.calendarState.enabled
                  )
                },
              ],
            },
          }),
          _c("span", { staticClass: "switcher__indicator" }),
        ]
      ),
    ]),
    _vm.calendarState.enabled
      ? _c(
          "div",
          {
            staticClass:
              "content-form__switch-hidden-field aside-select paddingless",
          },
          [
            _c(
              "div",
              { staticClass: "content-form__highlighted" },
              [
                _c(
                  "FormField",
                  {
                    staticClass: "side-form__item aside-input",
                    attrs: { label: "Date column" },
                  },
                  [
                    _c("v-select", {
                      attrs: {
                        items: _vm.cols,
                        "item-text": "label",
                        "item-value": "id",
                        "menu-props": "offsetY",
                        placeholder: "Date column",
                        "append-icon": "keyboard_arrow_down",
                      },
                      model: {
                        value: _vm.calendarState.startDateColId,
                        callback: function ($$v) {
                          _vm.$set(_vm.calendarState, "startDateColId", $$v)
                        },
                        expression: "calendarState.startDateColId",
                      },
                    }),
                    _c(
                      "a",
                      {
                        staticClass: "sorting-constructor__link",
                        attrs: {
                          target: "_blank",
                          href: "https://help.spreadsimple.com/en/article/setting-up-calendar-view-x2bb69/",
                        },
                      },
                      [_vm._v("Help: How to set up Calendar view?")]
                    ),
                  ],
                  1
                ),
                _c(
                  "FormField",
                  {
                    staticClass: "side-form__item aside-input",
                    attrs: { label: "Default view" },
                  },
                  [
                    _c("v-select", {
                      attrs: {
                        value: _vm.mapViewState.defaultView,
                        items: _vm.typeOptions,
                        "item-text": "label",
                        "item-value": "value",
                        "menu-props": "offsetY",
                        placeholder: "Default view",
                        "append-icon": "keyboard_arrow_down",
                      },
                      on: { change: _vm.onChangeDefaultView },
                    }),
                  ],
                  1
                ),
                _c(
                  "FormField",
                  {
                    staticClass: "side-form__item aside-input",
                    attrs: { label: "Week starts on" },
                  },
                  [
                    _c("v-select", {
                      attrs: {
                        items: _vm.weekStartsOnOptions,
                        "item-text": "label",
                        "item-value": "value",
                        "menu-props": "offsetY",
                        placeholder: "Week starts on",
                        "append-icon": "keyboard_arrow_down",
                      },
                      model: {
                        value: _vm.calendarState.weekStartsOn,
                        callback: function ($$v) {
                          _vm.$set(_vm.calendarState, "weekStartsOn", $$v)
                        },
                        expression: "calendarState.weekStartsOn",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }